import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

interface ErrorAlertProps {
    message: string;
    onDismiss?: () => void;
    showBillingLink?: boolean;
    onBillingClick?: () => void;
}

export default function ErrorAlert({
    message,
    onDismiss,
    showBillingLink = false,
    onBillingClick,
}: ErrorAlertProps) {
    const navigate = useNavigate();

    const handleBillingClick = () => {
        if (onBillingClick) {
            onBillingClick();
        } else {
            navigate("/dashboard/pricing");
        }
    };

    return (
        <Box
            sx={(theme) => ({
                p: 2,
                borderRadius: 1,
                border: "1px solid",
                borderColor: alpha(theme.palette.error.main, 0.5),
                backgroundColor: alpha(theme.palette.error.main, 0.1),
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
            })}
        >
            <Typography variant="body2" sx={{ mr: 2 }}>
                {message}
            </Typography>
            {showBillingLink && (
                <Button variant="contained" onClick={handleBillingClick}>
                    Upgrade
                </Button>
            )}
        </Box>
    );
}
